export default {
  colors: {blue: 'mediumseagreen', red: 'red', black: 'black', yellow: 'yellow'},
  margin: {},
  border: {},
  fontSize: {},
};
